export const faqs = [
  {
    question: '约炮需要付费吗？',
    answer: '约炮本身不需要付费，但部分社交平台的高级功能（如无限匹配、查看谁喜欢了你等）可能需要付费订阅。建议先免费体验，根据实际需求再决定是否付费。重要的是保持理性消费，不要被平台的营销策略诱导过度消费。',
  },
  {
    question: '第一次约炮应该选择什么地点？',
    answer: '强烈建议选择人多的公共场所，如咖啡厅、餐厅、商场等。这些地方安全、舒适，且方便随时离开。避免去对方家里、酒店或偏僻的地方进行第一次见面。给彼此足够的时间和空间来互相了解，再做下一步决定。',
  },
  {
    question: '如何判断对方是否靠谱？',
    answer: '可以从以下几个方面判断：1) 是否愿意进行视频通话验证身份；2) 聊天内容是否前后一致；3) 是否尊重你的边界和意愿；4) 是否愿意在公共场所见面。如果对方急于见面、拒绝视频验证、言语轻浮，建议提高警惕。',
  },
  {
    question: '约炮后如何保持关系？',
    answer: '如果双方都希望保持长期关系，关键是坦诚沟通和相互尊重。明确双方对关系的期待，保持适度的联系频率，不要给对方过多压力。同时也要接受关系可能随时结束的可能性，保持独立的自我。',
  },
  {
    question: '哪个约炮平台最适合新手？',
    answer: '对于新手，推荐从探探或Soul开始。探探操作简单，用户基数大，匹配效率高；Soul以声音和文字社交为主，降低了外貌焦虑。建议先在1-2个平台上积累经验，再根据个人偏好扩展到其他平台。',
  },
  {
    question: '如何在约炮中保护个人隐私？',
    answer: '保护隐私的要点包括：1) 使用社交软件的聊天功能而非直接加微信；2) 不透露详细的家庭住址和工作单位；3) 谨慎分享照片，避免包含可识别位置信息的照片；4) 使用专门的约炮社交账号，与日常社交账号分开。',
  },
  {
    question: '约炮失败了怎么办？',
    answer: '约炮失败是很正常的，不必过度自责。分析失败的原因：可能是双方需求不匹配、沟通不到位、时机不对等。把每次经历都当作学习的机会，调整策略后继续尝试。记住：约炮是一个概率游戏，尝试越多，成功概率越大。',
  },
  {
    question: '女性约炮有什么特别需要注意的？',
    answer: '女性在约炮中需要更加注意安全：1) 选择有女性保护机制的平台；2) 第一次见面务必选择公共场所；3) 告知朋友行踪，设置安全暗号；4) 不要因为对方请客就觉得有义务做什么；5) 相信自己的直觉，不舒服就离开。安全永远是第一位的。',
  },
];